import countries from '../../../../../json/countries.json'

import createDiscontinuationElement from '../../../common/createDiscontinuationElement'

export default (listUl, data, pageData) => {

  console.log({data, pageData});

  if (!data) {
    return;
  }

  const roundListUl = listUl;
  roundListUl.classList.add('_skelton');
  roundListUl.setAttribute('aria-hidden', true);
  const roundListItem = roundListUl.firstElementChild;

  const roundListItemContainer = [];
  const fragment = document.createDocumentFragment();
  const allImgLoadPromises = [].map.call(data.races, (raceData, rIdx) => {
    return new Promise(resolve => {
      const cloneListItem = roundListItem.cloneNode(true);

      const ttlEle = cloneListItem.querySelector('.le-group__ttl');
      ttlEle.textContent = raceData.title;
      const timeArea = cloneListItem.querySelector('.le-group__time');
      timeArea.classList.remove('_skelton')
      timeArea.removeAttribute('aria-hidden')
      cloneListItem.querySelector('.le-group__time-txt ._time').textContent = `${raceData.post_time}~`;

      if (raceData.isRaceDiscontinuation && !pageData.isAllRaceDiscontinuation) {
        timeArea.appendChild(createDiscontinuationElement(timeArea.className));
      }

      const btn = cloneListItem.querySelector('.c-btn-rcorner');
      /**
       * race_status
       *  1: 出走表なし
       *  2: 出走表あり and レース結果なし
       *  3: 出走表あり and レース結果あり
       */
      if (raceData.race_status != 1) {
        btn.disabled = false;
        btn.classList.remove('_disabled');
        btn.href = `/league/racecard/?race_id=${raceData.id}`;
        if (raceData.race_status == 3) {
          btn.classList.remove('_bg-black')
          btn.classList.add('_bg-white')
          btn.querySelector('.c-btn-rcorner__txt').textContent = 'レース結果'
        }
      }

      const contestantTable = cloneListItem.querySelector('.le-runtable');
      contestantTable.classList.remove('_skelton')
      contestantTable.removeAttribute('aria-hidden')

      // 出場選手が決まっている時の処理
      if (raceData.player_list.length > 0) {
        const runTableListItems = contestantTable.querySelectorAll('.le-runtable__list-item');
        const imgLoadPromises = [].map.call(runTableListItems, (item, lIdx) => {
          const playerId = raceData.player_list[lIdx] ? raceData.player_list[lIdx].id : 0;
          if (playerId) {
            item.querySelector(`.le-runtable__name`).textContent = raceData.player_list[lIdx].name;
            item.querySelector(`.le-runtable__countory`).textContent = countries[raceData.player_list[lIdx].country_code].code3;
            return new Promise(resolve => {
              const imgClassName = 'le-runtable__photo-img';
              const dummyImg = item.querySelector(`.${imgClassName}`)
              const img = new Image();
              img.classList.add(imgClassName);
              const name = raceData.player_list[lIdx].name;
              img.alt = name;
              img.onload = () => {
                dummyImg.before(img);
                dummyImg.remove();
                resolve();
              }
              img.onerror = () => {
                img.src = `/assets/images/common/card/img_card_back_thumb_noimage.png`;
              }
              img.src = `${window.pist6.imgOrigin}/player/${playerId}/410x536.png`;
            })
          } else {
            item.remove();
            return false
          }
        }).filter(promise => promise);

        Promise.all(imgLoadPromises)
          .then(() => {
            roundListItemContainer[rIdx] = cloneListItem;

            // 開催中止の際に resolve が実行されるので、2重実行を避けるため開催される場合のみ実行
            if (!raceData.isRaceDiscontinuation) {
              resolve();
            }
          })
      }

      // 下記のどちらかの時に処理が実行される
      // ・出場選手が決まっていない
      // ・レースの開催が中止
      if (raceData.player_list.length == 0 || raceData.isRaceDiscontinuation) {
        const { overlayText, isItalic } = (() => {
          // 開催中止時のテキスト
          if (raceData.isRaceDiscontinuation) {
            return {
              overlayText: '中止',
              isItalic: false
            }
          }

          // 開催前（出走選手未決定時）のテキスト
          return {
            overlayText: 'Coming Soon',
            isItalic: true
          }
        })();
        const isRuntableFlush = raceData.player_list.length == 0;
        const runTabelListItem = setRunTabelListItemOverlay(cloneListItem, overlayText, isItalic, isRuntableFlush);
        roundListItemContainer[rIdx] = runTabelListItem;
        resolve();
      }
    })
  })

  Promise.all(allImgLoadPromises)
    .then(() => {
      roundListItemContainer.forEach(listItemEle => fragment.appendChild(listItemEle))
      roundListUl.innerHTML = '';
      roundListUl.appendChild(fragment)

      roundListUl.classList.remove('_skelton')
      roundListUl.removeAttribute('aria-hidden')
    })

}

const setRunTabelListItemOverlay = (cloneListItem, overlayText, isItalic, isRuntabelFlush) => {
  const contestantTable = cloneListItem.querySelector('.le-runtable');

  // 出走データが入っていない時は出走表をクリアする（サムネ、名前、国籍）
  if (isRuntabelFlush) {
    const runTableListItems = contestantTable.querySelectorAll('.le-runtable__list-item');
    const contestantFragment = document.createDocumentFragment();
    runTableListItems.forEach(item => {
      item.querySelector(`.le-runtable__name`).textContent = '';
      item.querySelector(`.le-runtable__countory`).textContent = 'JPN';
      contestantFragment.appendChild(item)
    });
    const contestantList = contestantTable.firstElementChild;
    contestantList.innerHTML = '';
    contestantList.appendChild(contestantFragment);
  }

  contestantTable.appendChild(createOverlayElement(overlayText, isItalic));
  contestantTable.classList.add('_overlay')

  return cloneListItem;
}
const createOverlayElement = (overlayText, isItalic) => {
  const htmlString = `<p class="le-runtable__overlay-txt${isItalic ? ' _italic' : ''}">${overlayText}</p>`
  const comingElement = document.createElement('div');
  comingElement.classList.add('le-runtable__overlay');
  comingElement.innerHTML = htmlString;
  return comingElement;
}
